import(/* webpackMode: "eager" */ "/home/artofyou/web/stage-personalisation.artofyou.life/public_html/src/app/page.tsx");
